// Toate mesajele de utilizator
// Mesaje de validare și succes/eroare pentru aplicație (localizabile)
export const MESAJE = {
    // Autentificare
    LOGIN_SUCCES: 'Autentificare reușită! Bine ai revenit.',
    LOGIN_ERROR: 'Eroare la autentificare. Verifică emailul și parola.',
    LOGOUT_SUCCES: 'Te-ai delogat cu succes!',
    REGISTER_SUCCES: 'Cont creat! Verifică emailul pentru confirmare.',
    REGISTER_ERROR: 'Eroare la crearea contului. Încearcă din nou.',
    PAROLE_NECORESPUNZATOARE: 'Parolele nu coincid!',
    // Google Auth
    GOOGLE_AUTH_SUCCESS: 'Autentificare cu Google reușită!',
    GOOGLE_AUTH_ERROR: 'Eroare la autentificarea cu Google. Încearcă din nou.',
    GOOGLE_AUTH_CANCELLED: 'Autentificarea cu Google a fost anulată.',
    GOOGLE_AUTH_POPUP_BLOCKED: 'Popup-ul pentru Google a fost blocat. Te rugăm să îl permiți și să încerci din nou.',
    // ✅ Fix: Mesaje suplimentare pentru autentificare & rețea
    EROARE_AUTENTIFICARE: 'Date de autentificare incorecte.',
    EROARE_RLS: 'Acces interzis (RLS).',
    EROARE_RETEA: 'Eroare de rețea. Încercați din nou.',
    PAROLA_PREA_SLABA: 'Parola este prea slabă. Utilizați cel puțin 8 caractere, inclusiv cifre și simboluri.',
    // Mesaje de validare backend
    INVALID_TYPE: 'Tip de tranzacție invalid!',
    INVALID_CATEGORY: 'Categorie invalidă!',
    MISSING_REQUIRED_FIELD: 'Câmp obligatoriu lipsă!',
    NOT_FOUND: 'Resursa nu a fost găsită!',
    SERVER_ERROR: 'Eroare internă server!',
    // Mesaje de succes backend
    TRANSACTION_CREATED: 'Tranzacție adăugată cu succes!',
    TRANSACTION_UPDATED: 'Tranzacție actualizată cu succes!',
    TRANSACTION_DELETED: 'Tranzacție ștearsă cu succes!',
    // Mesaje formular
    CAMPURI_OBLIGATORII: 'Completează toate câmpurile obligatorii',
    FRECV_RECURENTA: 'Selectează frecvența pentru tranzacție recurentă',
    AVERTISMENT_DATE: 'Datele introduse nu sunt valide sau complete.',
    // Mesaje pentru operațiuni CRUD
    EROARE_ADAUGARE: 'Eroare la adăugare',
    SUCCES_ADAUGARE: 'Tranzacție adăugată cu succes',
    SUCCES_EDITARE: 'Tranzacție editată cu succes',
    SUCCES_STERGERE: 'Tranzacție ștearsă cu succes',
    CONFIRMARE_STERGERE: 'Sigur vrei să ștergi această tranzacție? Această acțiune nu poate fi anulată.',
    // Mesaje generale de eroare
    EROARE_GENERALA: 'A apărut o eroare neașteptată. Încearcă din nou sau contactează suportul.',
    EROARE_TITLU: 'Eroare neașteptată',
    EROARE_FORMAT_DATE: 'Format de date invalid sau neașteptat de la server.',
    EROARE_NECUNOSCUTA: 'Eroare necunoscută',
    // Mesaje pentru store-ul de tranzacții
    EROARE_INCARCARE_TRANZACTII: 'Eroare la încărcarea tranzacțiilor',
    EROARE_SALVARE_TRANZACTIE: 'Eroare la salvarea tranzacției',
    EROARE_CATEGORIE_SUBCATEGORIE_INVALIDA: 'Categoria sau subcategoria nu este validă',
    // Mesaje pentru sistemul de filtrare
    EROARE_FILTRARE: 'Eroare la aplicarea filtrelor',
    EROARE_SORTARE: 'Eroare la sortarea datelor',
    // Mesaje pentru paginare
    EROARE_INCARCARE_PAGINA: 'Eroare la încărcarea paginii',
    // Mesaje pentru exportul de date
    EROARE_EXPORT: 'Eroare la exportul datelor',
    SUCCES_EXPORT: 'Exportul a fost finalizat cu succes',
    // Mesaje pentru backup
    EROARE_BACKUP: 'Eroare la crearea backup-ului',
    SUCCES_BACKUP: 'Backup creat cu succes',
    EROARE_RESTAURARE: 'Eroare la restaurarea datelor',
    SUCCES_RESTAURARE: 'Datele au fost restaurate cu succes',
    // Mesaje pentru sincronizarea datelor
    EROARE_SINCRONIZARE: 'Eroare la sincronizarea datelor',
    SUCCES_SINCRONIZARE: 'Datele au fost sincronizate cu succes',
    SINCRONIZARE_IN_CURS: 'Sincronizare în curs...',
    // Mesaje pentru validarea formularelor
    VALIDARE_SUMA_OBLIGATORIE: 'Suma este obligatorie',
    VALIDARE_SUMA_POZITIVA: 'Suma trebuie să fie pozitivă',
    VALIDARE_DATA_OBLIGATORIE: 'Data este obligatorie',
    VALIDARE_CATEGORIE_OBLIGATORIE: 'Categoria este obligatorie',
    VALIDARE_TIP_OBLIGATORIU: 'Tipul tranzacției este obligatoriu',
    // Mesaje pentru tranzacții recurente (NOI)
    RECURRING_GENERATION_SUCCESS: 'Tranzacții recurente generate cu succes!',
    RECURRING_GENERATION_ERROR: 'Eroare la generarea tranzacțiilor recurente',
    RECURRING_RULE_NOT_FOUND: 'Regula recurentă nu a fost găsită sau este invalidă',
    RECURRING_GENERATION_UNAUTHORIZED: 'Nu aveți permisiunea de a genera tranzacții recurente',
    RECURRING_GENERATION_INVALID_PARAMS: 'Parametrii pentru generarea tranzacțiilor recurente sunt invalizi',
    RECURRING_GENERATION_IN_PROGRESS: 'Se generează tranzacții recurente...',
    RECURRING_GENERATION_PARTIAL: 'Unele tranzacții recurente nu au putut fi generate',
    RECURRING_RULE_INACTIVE: 'Regula recurentă este inactivă și nu poate genera tranzacții',
    RECURRING_LOOK_AHEAD_INVALID: 'Perioada de look-ahead trebuie să fie între 0 și 3650 de zile',
    // Mesaje pentru validare recurring rules (JSONB)
    RECURRING_RULE_AMOUNT_POSITIVE: 'Suma pentru regula recurentă trebuie să fie pozitivă',
    RECURRING_RULE_REQUIRED_FIELDS: 'Toate câmpurile obligatorii pentru regula recurentă trebuie completate',
    RECURRING_RULE_CONSTRAINT_VIOLATION: 'Regula recurentă nu respectă constrângerile de validare',
    RECURRING_RULE_ID_REQUIRED: 'ID pentru regula recurentă este obligatoriu',
    RECURRING_TRANSACTION_ID_REQUIRED: 'ID tranzacție este obligatoriu',
    RECURRING_RULE_INVALID_SCHEMA: 'Schema pentru regula recurentă este invalidă',
    RECURRING_RULE_FREQUENCY_INVALID: 'Frecvența specificată pentru regula recurentă nu este validă',
    // ✅ Fix: Mesaje pentru preferințele coloanelor (TransactionTable)
    COLUMN_ORDER_UPDATED: 'Ordinea coloanelor a fost salvată!',
    COLUMN_VISIBILITY_UPDATED: 'Vizibilitatea coloanelor a fost salvată!',
    COLUMN_PREFERENCES_RESET: 'Preferințele coloanelor au fost resetate la valorile implicite!',
    // ✅ Structură VALIDARE – folosită de errorHandling utils
    VALIDARE: {
        CAMP_LIPSA: 'Câmp obligatoriu lipsă!'
    },
    // ✅ Structură CATEGORII – folosită de CategoryEditor & hooks
    CATEGORII: {
        MAXIM_SUBCATEGORII: 'Ați atins numărul maxim de subcategorii permise.',
        SUBCATEGORIE_EXISTENTA: 'Subcategoria există deja în această categorie.',
        SUCCES_ADAUGARE_SUBCATEGORIE: 'Subcategoria a fost adăugată cu succes',
        CATEGORIA_NEGASITA: 'Categoria nu a fost găsită.',
        NU_SE_POT_STERGE_PREDEFINITE: 'Nu puteți șterge subcategoriile predefinite.',
        SUCCES_STERGERE_SUBCATEGORIE: 'Subcategoria a fost ștearsă cu succes',
        EROARE_STERGERE_SUBCATEGORIE: 'Eroare la ștergerea subcategoriei',
        EROARE_STERGERE: 'Eroare la ștergere',
        NUME_GOL: 'Numele nu poate fi gol',
    },
};
// Mesaje pentru LunarGrid
export const LUNAR_GRID_MESSAGES = {
    EROARE_INCARCARE: 'Eroare la încărcarea datelor',
    EROARE_CREARE_TRANZACTIE: 'Eroare la crearea tranzacției',
    EROARE_ACTUALIZARE_TRANZACTIE: 'Eroare la actualizarea tranzacției',
    EROARE_STERGERE_TRANZACTIE: 'Eroare la ștergerea tranzacției',
    // 🌍 I18N AUDIT - Transaction loading errors
    EROARE_INCARCARE_TRANZACTII: 'Eroare la încărcarea tranzacțiilor:',
    // 🌍 I18N AUDIT - Common error messages
    A_APARUT_EROARE: 'A apărut o eroare',
};
// Mesaje pentru Export
export const EXPORT_MESSAGES = {
    EROARE_GENERALA: 'Eroare la export. Vă rugăm încercați din nou.',
    EROARE_FORMAT: 'Format de export nesuportat. Formatele acceptate sunt: CSV, Excel, PDF.',
    EROARE_DATE_INVALIDE: 'Datele pentru export sunt invalide sau incomplete.',
    EROARE_TIMEOUT: 'Timpul de export a expirat. Încercați un set mai mic de date.',
    SUCCES: 'Export finalizat cu succes!',
    IN_PROGRES: 'Export în curs... {progress}%',
    ANULAT: 'Export anulat.',
    CONFIRMARE_MULTE_RANDURI: 'Sunteți pe cale să exportați {count} înregistrări. Continuați?',
    SUGESTIE_FILTRARE: 'Pentru exporturi mai rapide, filtrați datele înainte de export.',
    SALVARE: 'Fișierul va fi salvat în directorul de descărcări.',
    DESCHIDERE: 'Fișierul se va deschide automat după export.'
};
// Mesaje pentru URL și filtre
export const URL_PERSISTENCE = {
    LINK_COPIAT: 'Link cu filtrele curente copiat în clipboard!',
    LINK_NEGASIT: 'Nu s-au putut încărca filtrele din URL.',
    FILTRE_RESETATE: 'Filtrele au fost resetate.',
    FILTRE_INVALIDE: 'Unele filtre din URL nu sunt valide și au fost ignorate.',
    FILTRE_INCARCATE: 'Filtrele au fost încărcate din URL.',
    FILTRE_SALVATE: 'Filtrele au fost salvate în URL.'
};
// Mesaje pentru React 19 Forms
export const FORM_MESSAGES = {
    // Stări generale
    SUBMITTING: 'Se trimite...',
    SAVING: 'Se salvează...',
    LOADING: 'Se încarcă...',
    PROCESSING: 'Se procesează...',
    // Mesaje de succes
    SUBMIT_SUCCESS: 'Formular trimis cu succes!',
    SAVE_SUCCESS: 'Salvat cu succes!',
    UPDATE_SUCCESS: 'Actualizat cu succes!',
    DELETE_SUCCESS: 'Șters cu succes!',
    // Mesaje de eroare
    SUBMIT_ERROR: 'Eroare la trimiterea formularului. Vă rugăm încercați din nou.',
    VALIDATION_ERROR: 'Vă rugăm corectați erorile din formular.',
    NETWORK_ERROR: 'Eroare de conexiune. Verificați conexiunea la internet.',
    SERVER_ERROR: 'Eroare de server. Vă rugăm încercați mai târziu.',
    TIMEOUT_ERROR: 'Cererea a expirat. Vă rugăm încercați din nou.',
    // Validare câmpuri
    FIELD_REQUIRED: 'Acest câmp este obligatoriu',
    FIELD_INVALID: 'Valoare invalidă',
    FIELD_MIN_LENGTH: 'Minim {min} caractere',
    FIELD_MAX_LENGTH: 'Maxim {max} caractere',
    FIELD_MIN_VALUE: 'Valoarea minimă este {min}',
    FIELD_MAX_VALUE: 'Valoarea maximă este {max}',
    FIELD_PATTERN: 'Format invalid',
    FIELD_EMAIL: 'Adresă de email invalidă',
    FIELD_URL: 'URL invalid',
    FIELD_NUMBER: 'Trebuie să fie un număr',
    FIELD_INTEGER: 'Trebuie să fie un număr întreg',
    FIELD_DATE: 'Dată invalidă',
    // Acțiuni optimiste
    OPTIMISTIC_UPDATE: 'Actualizare în curs...',
    OPTIMISTIC_DELETE: 'Ștergere în curs...',
    OPTIMISTIC_CREATE: 'Creare în curs...',
    // Confirmări
    CONFIRM_DELETE: 'Sigur doriți să ștergeți?',
    CONFIRM_CANCEL: 'Sigur doriți să anulați? Modificările nesalvate se vor pierde.',
    CONFIRM_SUBMIT: 'Sigur doriți să trimiteți formularul?',
    // Stări speciale
    FORM_DIRTY: 'Aveți modificări nesalvate',
    FORM_SUBMITTING: 'Formular în curs de trimitere...',
    FORM_RESETTING: 'Se resetează formularul...',
    FORM_LOADING: 'Se încarcă datele formularului...'
};
/**
 * Funcție helper pentru obținerea mesajelor din constantele centralizate
 * @param key - Cheia mesajului
 * @param namespace - Namespace-ul din care să se obțină mesajul (opțional, va căuta automat)
 * @returns Mesajul corespunzător sau o valoare default
 */
export function getMessage(key, namespace) {
    if (namespace) {
        const messageMap = getMessageMap(namespace);
        return messageMap[key] || `[Missing message: ${namespace}.${key}]`;
    }
    // Caută automat în toate namespace-urile
    for (const ns of ['MESAJE', 'LUNAR_GRID_MESSAGES', 'EXPORT_MESSAGES', 'URL_PERSISTENCE', 'FORM_MESSAGES']) {
        const messageMap = getMessageMap(ns);
        if (messageMap[key]) {
            return messageMap[key];
        }
    }
    return `[Missing message: ${key}]`;
}
/**
 * Helper pentru obținerea map-ului de mesaje pentru un namespace
 */
function getMessageMap(namespace) {
    switch (namespace) {
        case 'MESAJE':
            return flattenObject(MESAJE);
        case 'LUNAR_GRID_MESSAGES':
            return LUNAR_GRID_MESSAGES;
        case 'EXPORT_MESSAGES':
            return flattenObject(EXPORT_MESSAGES);
        case 'URL_PERSISTENCE':
            return URL_PERSISTENCE;
        case 'FORM_MESSAGES':
            return FORM_MESSAGES;
        default:
            return {};
    }
}
/**
 * Helper pentru aplatizarea obiectelor nested (ex: MESAJE.VALIDARE.SUMA_INVALIDA -> 'VALIDARE.SUMA_INVALIDA')
 */
function flattenObject(obj, prefix = '') {
    const flattened = {};
    for (const key in obj) {
        const value = obj[key];
        const newKey = prefix ? `${prefix}.${key}` : key;
        if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
            Object.assign(flattened, flattenObject(value, newKey));
        }
        else if (typeof value === 'string') {
            flattened[key] = value;
            flattened[newKey] = value; // Include și varianta cu prefix complet
        }
    }
    return flattened;
}
